import { AccountBalanceRequest, AccountBalanceResponse } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// Direct-Pattern replacement for the portal's legacy usePostAccountBalance —
// the payables flow reads the available balance for its insufficient-funds
// guard before paying.
export default function useFetchAccountBalance() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [balanceResponse, setBalanceResponse] = useState<AccountBalanceResponse>();

  async function fetchAccountBalance(params: AccountBalanceRequest): Promise<AccountBalanceResponse> {
    try {
      setFetching(true);
      const res = await api.postAccountBalance(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setBalanceResponse(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, balanceResponse, fetchAccountBalance };
}
